import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css } from 'lit'


export const orderHistoryStyle = css`
  :host {
    display: flex;
    flex-flow: column;
    gap: ${csSpacing.spacing05};
  }

  csc-table-header-cell cse-text {
    padding-block: ${csSpacing.spacing05};
    padding-inline: ${csSpacing.spacing06};
  }
`
